import { SeoHead, organizationLd, webSiteLd, articleLd } from '../seo';

export default function About() {
  return (
    <>
      <SeoHead
        title="About Parksy.rent — India's Free Crowdsourced Parking Map"
        description="Parksy is India's crowdsourced vehicle parking map. Find, list, and compare real parking prices across India — free, anonymous, no brokerage."
        canonical="https://parksy.rent/about"
        ogImage="https://parksy.rent/og/about.png"
        ogType="article"
        publishedTime="2024-01-01"
        modifiedTime={new Date().toISOString().split('T')[0]}
        schemas={[
          organizationLd(),
          webSiteLd(),
          articleLd({
            headline: 'About Parksy.rent — India’s Free Crowdsourced Parking Map',
            description: 'How Parksy works, why it exists, and the principles behind India’s free crowdsourced parking map.',
            url: 'https://parksy.rent/about',
            image: 'https://parksy.rent/og/about.png',
            datePublished: '2024-01-01',
            dateModified: new Date().toISOString().split('T')[0],
            authorName: 'The Parksy team',
          }),
        ]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">About Parksy.rent</h1>

        <div className="prose prose-lg text-gray-600 space-y-6">
          <p>
            Parksy.rent is India's crowdsourced vehicle parking map. Our mission is simple:
            make parking space discoverable, transparent, and accessible — without brokers,
            without signup friction, and without paywalls.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Why parking?</h2>
          <p>
            In Indian metros, finding a safe, affordable parking spot is a daily struggle.
            Meanwhile, thousands of driveways, apartment slots, and commercial lots sit empty.
            Parksy connects the two sides directly: people with spare parking and people who need it.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">How it works</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>Drop a pin on the map where you have parking or need parking.</li>
            <li>Add details: vehicle type, price, security features, access hours.</li>
            <li>We match seekers with nearby listings and email both parties.</li>
            <li>Pin what you currently pay to help others negotiate fair rates.</li>
          </ol>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Free forever</h2>
          <p>
            No signup. No app download. No brokerage. Parksy is free for everyone.
            We plan to cover server costs through non-intrusive ads, similar to how
            Wikipedia and other community platforms operate.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Built for India</h2>
          <p>
            We understand that parking in India is different. Two-wheelers outnumber cars.
            Monthly rentals are common. Security guards and CCTV matter. Metro commuters need
            parking near stations. Parksy is designed with these realities in mind.
          </p>
        </div>
      </div>
    </>
  );
}
